import React from 'react'

const SettingsZonesIcon = (
  <>
    <path
      d="M8.00016 19.5833C12.3724 19.5833 15.9168 18.2775 15.9168 16.6667C15.9168 15.0558 12.3724 13.75 8.00016 13.75C3.62791 13.75 0.0834961 15.0558 0.0834961 16.6667C0.0834961 18.2775 3.62791 19.5833 8.00016 19.5833Z"
      fill="#9BCED3"
    />
    <path
      d="M8 0.416992C6.3424 0.416992 4.75268 1.07547 3.58058 2.24757C2.40848 3.41968 1.75 5.00939 1.75 6.66699C1.75 10.3957 6.4825 15.2087 7.71125 16.3937C7.78856 16.4688 7.89216 16.5109 8 16.5109C8.10784 16.5109 8.21144 16.4688 8.28875 16.3937C9.5175 15.2087 14.25 10.3957 14.25 6.66699C14.25 5.00939 13.5915 3.41968 12.4194 2.24757C11.2473 1.07547 9.6576 0.416992 8 0.416992Z"
      fill="#EAD8C5"
    />
    <path
      d="M11.3336 6.45834C11.3354 6.06962 11.2158 5.69005 10.9916 5.37252C10.7674 5.05499 10.4497 4.81531 10.0828 4.6869C9.7159 4.55849 9.31809 4.54773 8.9448 4.65614C8.5715 4.76455 8.24133 4.98671 8.00029 5.29167C7.84047 5.08993 7.6407 4.92337 7.41351 4.80243C7.18632 4.68148 6.9366 4.60876 6.67999 4.58882C6.42339 4.56889 6.16543 4.60216 5.92228 4.68655C5.67913 4.77094 5.45604 4.90464 5.26696 5.07927C5.07789 5.2539 4.92692 5.4657 4.82352 5.70139C4.72011 5.93708 4.66649 6.19158 4.66602 6.44896C4.66555 6.70634 4.71824 6.96104 4.82078 7.19711C4.92333 7.43317 5.07353 7.64552 5.26196 7.82084L8.00029 10.5354L10.7386 7.82209C10.9261 7.64776 11.0756 7.43672 11.178 7.2021C11.2803 6.96748 11.3333 6.71431 11.3336 6.45834Z"
      fill="#ED7064"
    />
  </>
)

export default SettingsZonesIcon
